// Currency and Region Configuration for CloudGM Platform

// Available Currencies
export const CURRENCIES = {
  AED: {
    code: 'AED',
    symbol: 'د.إ',
    name: 'درهم إماراتي',
    nameEn: 'UAE Dirham',
    position: 'after', // symbol position: 'before' or 'after'
    decimals: 2
  },
  USD: {
    code: 'USD',
    symbol: '$',
    name: 'دولار أمريكي',
    nameEn: 'US Dollar',
    position: 'before',
    decimals: 2
  },
  EUR: {
    code: 'EUR',
    symbol: '€',
    name: 'يورو',
    nameEn: 'Euro',
    position: 'before',
    decimals: 2
  },
  CNY: {
    code: 'CNY',
    symbol: '¥',
    name: 'يوان صيني',
    nameEn: 'Chinese Yuan',
    position: 'before',
    decimals: 2
  }
};

// Available Regions
export const REGIONS = {
  UAE: {
    code: 'UAE',
    name: 'الإمارات',
    nameEn: 'UAE',
    flag: '🇦🇪',
    currency: 'AED',
    phoneCode: '+971',
    available: true
  },
  USA: {
    code: 'USA',
    name: 'الولايات المتحدة',
    nameEn: 'United States',
    flag: '🇺🇸',
    currency: 'USD',
    phoneCode: '+1',
    available: false // Coming soon
  },
  EU: {
    code: 'EU',
    name: 'الاتحاد الأوروبي',
    nameEn: 'European Union',
    flag: '🇪🇺',
    currency: 'EUR',
    phoneCode: '',
    available: false // Coming soon
  },
  CHINA: {
    code: 'CHINA',
    name: 'الصين',
    nameEn: 'China',
    flag: '🇨🇳',
    currency: 'CNY',
    phoneCode: '+86',
    available: false // Coming soon
  }
};

// Default region
export const DEFAULT_REGION = 'UAE';

// Get current region from localStorage or default
export const getCurrentRegion = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('cloudgm_region') || DEFAULT_REGION;
  }
  return DEFAULT_REGION;
};

// Set current region
export const setCurrentRegion = (regionCode) => {
  if (typeof window !== 'undefined' && REGIONS[regionCode]) {
    localStorage.setItem('cloudgm_region', regionCode);
    // Trigger a custom event for components to react
    window.dispatchEvent(new CustomEvent('regionChange', { detail: regionCode }));
  }
};

// Get region config
export const getRegionConfig = (regionCode = null) => {
  const code = regionCode || getCurrentRegion();
  return REGIONS[code] || REGIONS[DEFAULT_REGION];
};

// Get currency config for current region
export const getCurrencyConfig = (regionCode = null) => {
  const region = getRegionConfig(regionCode);
  return CURRENCIES[region.currency];
};

// Format price with currency symbol
export const formatPrice = (price, regionCode = null) => {
  const currency = getCurrencyConfig(regionCode);
  const formattedNumber = price.toLocaleString('en-US', {
    minimumFractionDigits: 0,
    maximumFractionDigits: currency.decimals
  });
  
  if (currency.position === 'before') {
    return `${currency.symbol}${formattedNumber}`;
  } else {
    return `${formattedNumber} ${currency.symbol}`;
  }
};

// Get just the currency symbol
export const getCurrencySymbol = (regionCode = null) => {
  return getCurrencyConfig(regionCode).symbol;
};

// Get available regions only
export const getAvailableRegions = () => {
  return Object.values(REGIONS).filter(region => region.available);
};

// Get all regions (including coming soon)
export const getAllRegions = () => {
  return Object.values(REGIONS);
};
